import styled from 'styled-components';
import LightThemedImg from './../../assets/layout-bg.svg';
import DarkThemedImg from './../../assets/dark-bg.jpg';
import { ThemeEnum } from '../../handlers/ThemeHandler';

export const Layout = styled.div`
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  justify-content: space-between;
  background-image: url(${({ theme }) =>
    theme.theme === ThemeEnum.light ? LightThemedImg : DarkThemedImg});
`;
